import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_red_down",
  "use": "icon-ic_red_down-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ic_red_down\">\r\n<path d=\"M13.5917 10.3252H10.0917L11.375 9.04186L8.34167 5.9502L5.13333 9.15853L0 4.08353L0.875 3.20853L5.13333 7.46686L8.34167 4.25853L12.25 8.16686L13.5917 6.8252V10.3252Z\" fill=\"#E54B4B\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol